import * as React from 'react';
import './UnderConstruction.scss';

const UnderConstruction = () => {
  const IMG = (imgName: string) => {
    return require(`./../../../../../../assets/images/jpg/${imgName}.jpg`)
      ?.default;
  };

  return (
    <div className="flex items-center justify-center custom-height">
      <img
        src={IMG("under-construction")}
        className="object-contain w-3/4 h-3/4"
        alt="under construction"
      ></img>
    </div>
  );
};

export default UnderConstruction;
